import { IconButton } from '@/components/ui/icon-button'
import { Moon, Sun } from 'lucide-solid'
import { Show, createSignal, onMount } from 'solid-js'
import { css } from 'styled-system/css'

export const attachDarkModeToHtml = (darkmode: boolean = persistedDarkmode) => {
  const html = document.querySelector('html')
  html?.classList.remove('dark', 'light')
  html?.classList.add(darkmode ? 'dark' : 'light')
}

export const persistedDarkmode = JSON.parse(localStorage.getItem('darkmode') ?? 'false')
export const [darkmode, setDarkMode] = createSignal(persistedDarkmode)

export const DarkMode = () => {
  const toggleDarkMode = () => {
    localStorage.setItem('darkmode', String(!darkmode()))
    setDarkMode(!darkmode())
    attachDarkModeToHtml(darkmode())
  }

  onMount(() => attachDarkModeToHtml(darkmode()))

  return (
    <div>
      <IconButton
        size='sm'
        onClick={toggleDarkMode}
        color='fg.subtle'
        variant="plain"
      >
        <Show
          when={darkmode()}
          fallback={<Sun />}
        >
          <Moon />
        </Show>
      </IconButton>
    </div>
  )
}
